import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class EventsCardComponent extends Component
{
	@service store;

	@tracked isAddingNewEvent = false;

	@tracked newEventName = "";
	@tracked newEventDate = null;
	@tracked newEventLocation = "";
	@tracked newEventVenue = "";

	@action
	dateChanged(newDate)
	{
		this.newEventDate = newDate[0];
	}

	@action
	cancelNewEvent()
	{
		this.isAddingNewEvent = false;
		this.newEventName = "";
		this.newEventDate = null;
		this.newEventLocation = "";
		this.newEventVenue = "";
	}

	@action
	async saveNewEvent()
	{
		const newEvent = this.store.createRecord('event',
		{
			name:this.newEventName,
			date:this.newEventDate,
			location:this.newEventLocation,
			venue:this.newEventVenue
		});

		try
		{
			await newEvent.save();
		}
		catch (error)
		{
			// Error is displayed by the adapter
			newEvent.rollbackAttributes();
			return;
		}

		this.isAddingNewEvent = false;
		this.newEventName = "";
		this.newEventDate = null;
		this.newEventLocation = "";
		this.newEventVenue = "";
	}
}